import {CONST} from '../../config'
import {dateToText, convNumberFormat}  from '../../util'
const isIE = /*@cc_on!@*/false || !!document.documentMode;
/*************************************************************
 * CellActMixin
 *     셀의 동작과 관련된 행위를 처리하는 Mixin 입니다.
 *      ex) 셀 선택-이동, 셀 수정
 *************************************************************/
export default {
    data() {return {
        mx_cClipboard : false,
    }},
    methods: {
        // [METHODS] Copy, Get data for copy. /w sel select
        mx_getCopyData() {
            var rtn = {};
            const COLS = this.mx_fieldsInfo
                , DATA = this.mx_getViewData()
                , cmap = this.mx_fieldMap;
            // 0. Prepare
            var fils = [],
                fil1 = this.mx_cSelFilSt,
                fil2 = this.mx_cSelFilEd,
                fil0 = null;
            // 0.1 make field list
            COLS.find(f => {
                if(!fil0 && (f.value === fil1 || f.value === fil2)) {
                    fil0 = f.value === fil1 ? fil2 : fil1;
                }
                // 2.2.2.2 Add diff
                if(f.hide) {return false;}
                if(fil0) {fils.push(f.value)}
                // 2.2.2.3 Check last cell
                return fil0 && (f.value === fil0);
            })
            // 0.2 Make min/max row
            var min = Math.min(this.mx_cSelIdxSt, this.mx_cSelIdxEd, DATA.length),
                max = Math.max(this.mx_cSelIdxSt, this.mx_cSelIdxEd, 0);
            // 0.3 Value array
            var valueArr = [];
            for(var i=min, ii=max ; i<=ii ; i++ ) {
                valueArr.push(fils.map(f => this.mx_showText(DATA[i][f], DATA[i], cmap.get(f)) ));
            }
            // 1. Build text
            rtn.Text = valueArr.map(r => r.join('\t')).join('\n')
            
            return rtn;
        },
        // [METHODS] Paste, Set paste data.
        mx_setPasteData(v) {
            if(isIE) {
                const readText = window.clipboardData.getData('Text')
                this.__pasteToGrid(readText);
            } else if(navigator.clipboard) {
                navigator.clipboard.readText().then(readText =>{
                    this.__pasteToGrid(readText);
                })
            } else {
                const $elm = this.mx_refs.clipboard
                if(!$elm) {console.warn('[UIDev] Fail to copy data');return;}
                $elm.select();
                document.execCommand('paste')
                setTimeout(()=> {
                    this.__pasteToGrid($elm.value);
                    $elm.value = '';
                })
            }
        },
        // [METHODS] Paste, save data
        /* NOSONAR */__pasteToGrid(v) {
            if(!v) return;
            // 0. Some datas
            const COLS = this.mx_fieldsInfo,
                  SELIDX = this.mx_cSelIdxSt,
                  SELFIL = this.mx_cSelFilSt;
            var data = this.mx_getViewData();
            // 1. Split data
            // 1.1 Split data
            var paste = v.split('\n').map(r=>r.split('\t'));
            // 1.2 Success split?
            if(!paste.length) return;
            // 1.3 Check final row
            var lastRow = paste[paste.length-1];
            if(!lastRow || !lastRow.length ||
                    (lastRow.length === 1 && !lastRow[0])) {
                paste.splice(-1);
            }
            var filLength = paste[0].length;
            // 2. Prepare grid data
            const fil0 = SELFIL;
            var fils = [],
                onField = false;
            if(!fil0) return;
            // 2.1 make field list
            COLS.find(f => {
                // 2.1.1 make onField
                if(!onField) {
                    if(fil0 === f.value) {onField=true}
                    else {return false}
                }
                // 2.2.2 If hide
                if(f.hide) {return false;}
                // 2.2.3 Push fils
                fils.push(f);
                filLength--;
                // 2.2.4 Is finish?
                return filLength <= 0;
            })
            
            // 3. Set data -> forLoop
            // 3.1 check create? and new line is enough?
            const firstRow = data[SELIDX];
            var pLen = paste.length;;
            if(this.mx_options.autoCreateOnPaste &&
                    firstRow && firstRow.__dirty === CONST.VAL.DIRTY.FLAG.CREATE) {
                // 3.1.1 check data...
                for(let i=0, ii=pLen; i<ii ; i++) {
                    var row = data[SELIDX+i];
                    if(!row || row.__dirty !== CONST.VAL.DIRTY.FLAG.CREATE) {
                        break;
                    }
                    pLen--;
                }
                for(let i=0, ii=pLen; i<ii; i++ ) {
                    this.mx_createEmptyRow(SELIDX+1);
                }
                
                if(pLen>0) {
                    this.mx_buildData(); // 괜차늠? 이거 좀 위험한데..
                    data = this.mx_getViewData(); // 리일로-드
                }
            }
            
            // 3.2 set data
            var changed = 0;
            for(var i=0, ii=paste.length; i<ii ; i++) {
                let row = data[i+SELIDX],
                    pow = paste[i];
                fils.forEach((fil,fidx) => {
                    // !! check editable
                    if(fil.readonly) {return}
                    if(row.__dirty === CONST.VAL.DIRTY.FLAG.UPDATE && !fil.edit) {return}
                    let v = this.mx_textToValue(pow[fidx], row, fil);
                    this.mx_setValue(row, fil.value, v);
                    changed++;
                })
            }
            // x. byebye
            if(changed) {
                this.mx_fireEvent('data-changed',this.mx_getChanged());
            }
        },
        // [METHODS] Copy, Copy data to clipboard
        mx_copyToClipboard() {
            const copyText = this.mx_getCopyData().Text;
            if(isIE) {
                window.clipboardData.setData('Text', copyText)
                this.mx_cClipboard = true;
            } else if(navigator.clipboard){
                navigator.clipboard.writeText(copyText).then(()=>{
                    // Positive callback
                    this.mx_cClipboard = true;
                }, ()=>{
                    // Negative callback
                    console.warn('[UIDev] Fail to copy data')
                });
            } else {
                const $elm = this.mx_refs.clipboard
                if(!$elm) {console.warn('[UIDev] Fail to copy data');return;}
                $elm.value = copyText;
                $elm.select();
                document.execCommand('copy')
                $elm.value = '';
                this.mx_cClipboard = true;
            }
        },
        // [METHODS] Copy, Set paste data.
        mx_clearClipboard() {
            this.mx_cClipboard = false;
            /**************** 
            //일단은 esc 누른다고 clipboard를 지우지는 당장은 않겠슴다.
            const emptyText = ''
            if(isIE) {
                window.clipboardData.setData('Text', emptyText)
                this.mx_cClipboard = false;
            } else {
                navigator.clipboard.writeText(emptyText).then(()=>{
                    // Positive callback
                    this.mx_cClipboard = false;
                }, ()=>{
                    // Negative callback
                    console.warn('[UIDev] Fail to copy data')
                });
            }/**/
        },
        // [METHODS] Util, Convert field values.
        mx_showText(v, r, f) {
            const opts = this.mx_options;
            // 1. Custom value
            const cv = f.customValue;
            if(cv && typeof cv ==='function') {
                return cv(v, r);
            }
            // 2. Typed values
            switch(f.type) {
            case 'date':
                const fmt = f.dateFormat || opts.dateFormat;
                const timezone = f.timezone===null ? opts.timezone : f.timezone;
                return dateToText(v, fmt, timezone);
            case 'code':
                if(f.__domainMap) {
                    var dobj = f.__domainMap.get(v);
                    return dobj?dobj.text:v;
                } else {
                    return v;
                }
            case 'number':
                if(v===null||v===undefined) return ''
                return convNumberFormat(v, f.numberFormat || opts.numberFormat)
            default:
                return v;
            }
        },
        // [METHODS] Util, Convert text to field value.
        /* NOSONAR */mx_textToValue(v, r, f) {
            // 1. Custom converter
            if(typeof f.pasteConverter === 'function') {
                return f.pasteConverter(v?v.trim():'',r,f)
            }
            // 2. Typed value
            switch(f.type) {
            case 'date':
                var dt = new Date(v.replace(/-/g,'/'));
                // 1. check timezone
                const timezone = f.timezone===null ? this.mx_options.timezone : f.timezone;
                if(typeof timezone === 'number') {
                    const OF = dt.getTimezoneOffset();
                    const TZ = timezone * -1 * 60;
                    dt = new Date(dt.getTime() + (TZ-OF)*60*1000);
                }
                if(isNaN(dt.getTime())) {return null};
                // 2. edit type for date value
                const returnType = this.mx_options.dateReturnType,
                      format = this.mx_options.dateFormat;
                switch(returnType) {
                case 'date'  : return dt;
                case 'long'  : return dt.getTime();
                case 'string': return dateToText(dt, format)}
                break;
            case 'code':
                if(f.__domainMap && f.__domainMap.has(v)) {
                    break;
                }
                if(f.__cotextMap) {
                    var cv = f.__cotextMap.get(v.trim())
                    return cv ? cv.value : v;
                } else {break;}
            case 'number':
                if(v !== 0 && (v===null || v===undefined)) {return null}
                let nv = parseFloat(v.replace(/,/g,''));
                if(isNaN(nv)) return null;
                return nv;
            default :
                return trim(v);
            }
            
            // x. Assume value is string
            return trim(v);
        }
    }
}


function trim(v) {
    if(!v || v.trim) return v;
    return v.trim()
}

